import React from 'react';
import { Notification } from '../../Notifications/types';
import { Notifications } from '../../Notifications/Notifications';

type Value = {
  pushNotification: (notification: Notification) => void;
  removeNotification: (notification: Notification) => void;
};

const errorMessage = 'Notification context is missing a Provider';

const defaultValue: Value = {
  pushNotification: () => {
    throw new Error(errorMessage);
  },
  removeNotification: () => {
    throw new Error(errorMessage);
  },
};

export const NotificationContext = React.createContext(defaultValue);

export const NotificationProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [notifications, setNotifications] = React.useState<Notification[]>([]);

  const pushNotification = (toPush: Notification) =>
    setNotifications(notifications => [toPush, ...notifications]);

  const removeNotification = (toRemove: Notification) =>
    setNotifications(notifications =>
      notifications.filter(notification => notification.id !== toRemove.id)
    );

  return (
    <NotificationContext.Provider
      value={{ pushNotification, removeNotification }}
    >
      {children}

      <Notifications
        notifications={notifications}
        removeNotification={removeNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () =>
  React.useContext(NotificationContext);
